import React from 'react'
const FeatureData = (props) => {
    const {feature_name, feature_synonyms} = props;
    let synonymsHtml = '';
    if(feature_synonyms.length > 0){
        synonymsHtml = feature_synonyms.map((synonymsData,i) => 
            <span key={i} className="badge badge-secondary me-2">
                {synonymsData?.value}
            </span>
        )
    }
    return(
        <>
            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                <div className="row mb-3">
                    <label className="col-lg-3 fw-semibold text-muted">
                        Feature name
                    </label>
                    <div className="col-lg-9">
                        <span className="fw-bold fs-6 text-gray-800">
                            {feature_name}
                        </span>
                    </div>
                </div>
                <div className="row mb-3">
                    <label className="col-lg-3 fw-semibold text-muted">
                        Feature synonyms
                    </label>
                    <div className="col-lg-9">
                        {synonymsHtml}
                    </div>
                </div>
            </div>
        </>
    );
}
const FeatureList = (props) => {
    const { feature_data } = props;
    let featureDataHtml = '';
    if( feature_data.length > 0 ){
        featureDataHtml = feature_data.map((featureData,i) => 
            <FeatureData
                key={i}
                feature_name={featureData.feature_name}
                feature_synonyms={featureData.feature_synonyms}
            />
        )
    }
    return (
        <>
            <div className='row'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Feature List
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 2 feature are available
                                </span>
                            </h3>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-5">
                            {featureDataHtml}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FeatureList